// extracted by mini-css-extract-plugin
export default {"selected-items-extras":"_2LBVL","selectedItemsExtras":"_2LBVL"};